export default __webpack_public_path__ + "static/quemSomos-13d95bec2abe9aee361c307e11be6764.png";